const state={   //要设置的全局访问的state对象
    token: null,
  };
const getters = {   //实时监听state值的变化(最新状态)
   getToken() { 
      return state.token
   }
};
const mutations = {
   newToken(state,token){ 
      state.token=token;
   },
   oldToken(state){
      return state.token;
   }
};
const actions = {
   updateTaken(context,token){   
       context.commit('newToken',token)
    },
    getTheToken(context){
       context.commit("oldToken");
    }
};
export default {
   namespaced: true, //用于在全局引用此文里的方法时标识这一个的文件名
   state,
   getters,
   mutations,
   actions
}